export default "__VITE_ASSET__BqOM6MgU__"